import { render, staticRenderFns } from "./printItem.vue?vue&type=template&id=2dd4b8d6"
import script from "./printItem.vue?vue&type=script&lang=js"
export * from "./printItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports